import { render, staticRenderFns } from "./MarginHelpPopups.vue?vue&type=template&id=f37c27be&scoped=true&"
import script from "./MarginHelpPopups.vue?vue&type=script&lang=js&"
export * from "./MarginHelpPopups.vue?vue&type=script&lang=js&"
import style0 from "./MarginHelpPopups.vue?vue&type=style&index=0&id=f37c27be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37c27be",
  null
  
)

export default component.exports